import { Header } from './Header';
import { useState, useEffect } from 'react';
import { Form, Input, Button, Alert, message, Steps, InputNumber, Modal , Select  } from "antd";
import {api} from '../helper/axios/index'
import formatDateToCustomString from './ConverterDate'
import { Spin } from "antd";
import './Style/Taxe.style.css'
import {setTaxe} from '../Routes/index'
import  {useDispatch}  from 'react-redux';
import { useSelector } from 'react-redux';
import {useNavigate} from 'react-router-dom';
import numeral from 'numeral';

export const Taxe = ()=>{

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [menuActive, setMenuActive] = useState(false);

    const handleMenuClick = () => {
      setMenuActive(prevState => !prevState);
    };

    const ENDPOINT = "invoice/me"
    const ENDPOINTPAY = "/invoice"
   
    const facture = useSelector(state=> state.notification)

    useEffect(() => {
        fetchData();
     //   initSSE();
      }, []);
    
      const fetchData = async () => {
        try {
          const response = await api.get(ENDPOINT);
          console.log("Mes données brut : ", response.data)
          const dataWithKeys = response.data.map((item) => ({
            key: item.id,
            last_name: item.taxPayer.user.last_name,
            first_name: item.taxPayer.user.first_name,
            idFacture: item.id,
            createdAt: item.createdAt,
            lastDelay: item.lastDelay,
            civiliter: item.taxPayer.user.civiliter,
            payment: item.payment.length,
            title: item.tax?.title,
            penality: item.tax?.penality,
            rising: item.montant,
            isPayed: item.isPayed
          }));
          setLoading(false)
          dispatch(setTaxe(dataWithKeys.reverse()))
        } catch (error) {
         console.log("Message d'erreur :" +error)
        }
      };      

      const handlePayement = async(objet)=>{
        try {
            const reponse = await api.get(`${ENDPOINTPAY}/${objet.idFacture}/payment`);
            console.log("Liens de payement : ", reponse.data)
            window.location.href= reponse.data.url
          } catch (error) {
           console.log("Message d'erreur : ",error)
          }
      }

      const [loading, setLoading] = useState(true)
      const [loadingCardId, setLoadingCardId] = useState(null);
      const [loadingPay, setLoadingPay] = useState(false) 

      const handleItemClick = (clickedItem) => {
        console.log('Élément cliqué :', clickedItem);
        setLoadingCardId(clickedItem.idFacture)
      handlePayement(clickedItem)
      setLoadingPay(true)
      };
      const [modal, contextHolder] = Modal.useModal();
      const countDown = () => {
        let secondsToGo = 10;
        const instance = modal.success({
          title: 'Cette taxe a déjà été réglée',
          content: `Vous ne pouvez payer que les taxes dont le statut est impayé.`,
           onOk:()=>{
              
           }
      });
      setTimeout(() => {
        instance.destroy();
      }, secondsToGo * 1000);
    };

    const [modals, contextHolders] = Modal.useModal();
    const countDowns = () => {
      let secondsToGo = 10;
      const instance = modals.success({
        title: 'Une taxe est actuellement en cours de traitement',
        content: `Il n'est pas possible de régler deux taxes simultanément`,
         onOk:()=>{
            
         }
    });
    setTimeout(() => {
      instance.destroy();
    }, secondsToGo * 1000);
  };

     const handleItemClickPaye=(objet)=>{
       if(objet.isPayed & !loadingCardId){
        countDown()
       }else{
        countDowns()
       }

     }
   
    return(
        
        <>
        {contextHolder}{contextHolders}
        <Header menuActive={menuActive} handleMenuClick={handleMenuClick} />
        <div className="main-banner wow fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s">
          <div className="container" style={{ marginTop: "-5em" }}>
            <div className="row">
              {loading && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60vh",
                    }}
                  >
                    <Spin spinning={loading} size="large" />
                    <h6 style={{ marginTop: "15px" }}>
                      Chargement des données...
                    </h6>
                  </div>
                </div>
              )}
  
              {facture?.map((item) => (
                <div className="col-lg-4 mb-5 " key={item.key} onClick={() => (!loadingCardId & item.payment < 1)? handleItemClick(item): handleItemClickPaye(item)}
                  style={{ display: loading ? 'none' : 'block' }}>
                  <div className="card-body mx-4 shadow position-relative" style={{ cursor: 'pointer' }}>
                    {loadingCardId == item.idFacture ? (
                        <>           
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" >
                        <div className="text-center">
                            <Spin spinning={loadingPay} size="large" />
                            <p style={{ marginTop: "10px", fontSize:"20px"}}>
                            Redirection vers la page de paiement
                            </p>
                        </div>
                        </div>
                      <div className="container" style={{filter:"blur(3px)"}}>
                        <p className="my-5 text-center" style={{ fontSize: "20px" }}>{item.title}</p>
                        <div className="row">
                          <ul className="list-unstyled">
                            <li className="text-black">{item.civiliter} {item.last_name} {item.first_name}</li>
                            <li className="text-muted mt-1 text-end"><span className="text-black">facture</span> #0000{item.idFacture} </li>
                          </ul>
                          <hr />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Date de création : <span className="float-end ">{formatDateToCustomString(item.createdAt)}</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Dernier délai : <span className="float-end ">{formatDateToCustomString(item.lastDelay)} </span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Penalité: <span className="float-end">{item.penality} FCFA</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Montant à payer: <span className="float-end fw-bold">{item.rising} FCFA</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                      </div>
                      </>
                      
                    ) : (
                      <div className="container" >
                        {item.payment < 1 ? (
                          <span style={{ width: "10em", height: "2em" }} className="my-3 position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                            impayé
                          </span>
                        ) : (
                          <span style={{ width: "10em", height: "2em" }} className="my-3 position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                            payé
                          </span>
                        )}
  
                        <p className="my-5 text-center" style={{ fontSize: "20px" }}>{item.title}</p>
                        <div className="row">
                          <ul className="list-unstyled">
                            <li className="text-black">{item.civiliter} {item.last_name} {item.first_name}</li>
                            <li className="text-muted mt-1 text-end"><span className="text-black">facture</span> #0000{item.idFacture} </li>
                          </ul>
                          <hr />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Date de création : <span className="float-end ">{formatDateToCustomString(item.createdAt)}</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Dernier délai : <span className="float-end ">{formatDateToCustomString(item.lastDelay)} </span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Penalité: <span className="float-end">{item.penality} FCFA</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                        <div className="row text-black">
                          <div className="col-xl-12">
                            <p>Montant à payer: <span className="float-end fw-bold">{numeral(item.rising).format('0,0')} FCFA</span>
                            </p>
                          </div>
                          <hr style={{ border: "2px solid black" }} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    )
}